import router from '@/router'
import store from '@/store'

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
   return JSON.parse(sessionStorage.getItem('expressions') || '[]').indexOf(key) !== -1 || false
  //TODO 开发用
  // console.log(key)
  //return true
}

export function isMulti(arr = []) {
  return arr.length > 1
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('tenantId')
  sessionStorage.removeItem('tenantName')
  sessionStorage.removeItem('mainBodyId')
  sessionStorage.removeItem('mainBodyName')
  sessionStorage.removeItem('sppwd')
  store.commit('resetStore')
  router.options.dynamicRoutesLoaded = false
}
//处理输入数字 默认保留3位
export function CHECK_NUMBER(value,precision=3){

  let reg = /^(\-)*(\d+)\.(\d\d\d).*$/;
  if(precision == 2){
    reg = /^(\-)*(\d+)\.(\d\d).*$/;
  }

  //处理负数
  let start = null;
  var price = '' + value;
  if(price.length>1 && price.substring(0,1) == '-'){
    start=price.substring(0,1);
    price = price.substring(1,price.length);
  }

  price = price
  .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
  .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
  .replace(/^\./g, '')    //保证第一个为数字而不是.
  .replace(/\.$/, '')    //如果以"."结尾去掉"."
  .replace('.', '$#$')
  .replace(/\./g, '')
  .replace('$#$', '.')
  .replace(reg, '$1$2.$3') // 只能输入precision个小数
  if (price.indexOf('.') < 0 && price != '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    price = parseFloat(price);
  }
  if(start){
    price =price*-1;
  }
  return price
}

function getNowMonth() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    month = month > 9 ? month : "0" + month;
    var nowMonth = year + "-" + month;
    return nowMonth;
}

/**获取上一个月 */
export function getPreMonth() {
    var arr = getNowMonth().split("-");
    var year = arr[0]; //获取当前日期的年份
    var month = arr[1]; //获取当前日期的月份

    var year2 = year;
    var month2 = parseInt(month) - 1;
    if (month2 == 0) {
        //1月的上一月是前一年的12月
        year2 = parseInt(year2) - 1;
        month2 = 12;
    }

    if (month2 < 10) {
        //10月之前都需要补0
        month2 = "0" + month2;
    }
    var preMonth = year2 + "-" + month2;
    return preMonth;
}
